// extracted by mini-css-extract-plugin
module.exports = {"btn-transfer":"TransferModal_btn-transfer__2tggd"};